import React from "react";
import ContactForm from "../../content/pages/home/contact/form/ContactForm";
import "./Contact.scss";

function Contact() {
  return (
    <div className="section-contact-page">
      <div className="section-contact-page-left">
        <div className="section-contact-page-left-top">
          <h2>Let's Talk</h2>
          <p>
            Looking to start a project or just need to collaborate? Feel Free to
            contact me.
          </p>
          <a href="mailto:contact@anuka.live">contact@anuka.live</a>
        </div>
        <div className="section-contact-page-left-bottom">
          <ContactForm />
        </div>
      </div>
      <div className="section-contact-page-right">
        <img
          src="https://res.cloudinary.com/dvwkvoqss/image/upload/v1750414590/background_uhyth1.webp"
          alt="background decoration"
        />
      </div>
    </div>
  );
}

export default Contact;
